module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": _vm.errorMessage
    }
  }, [_c('Button', {
    attrs: {
      "bordered": true,
      "autowidth": true
    },
    on: {
      "click": _vm.closeMessages
    }
  }, [_vm._v("Закрыть")])], 1) : [_c('InnerMenu', {
    attrs: {
      "menu": _vm.innerMenu
    }
  }), (_vm.successWarning) ? _c('MentoringSuccess', {
    on: {
      "backToForm": _vm.backToForm,
      "toAllRequest": _vm.toAllRequest
    }
  }) : _c('router-view', {
    attrs: {
      "items": _vm.requests
    },
    on: {
      "emitRequestForm": _vm.submitRequestForm
    }
  }), (_vm.notNewRequestRoute) ? _c('OpenForm', {
    attrs: {
      "mainText": "Нажмите + чтобы создать новый запрос",
      "helpText": "Опубликованный запрос позволит участвовать в наставнической программе."
    },
    on: {
      "openForm": _vm.openForm
    }
  }) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fecfea9","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/requests/MentoringRequests.vue
// module id = 08dee88eac5ee257a03b
// module chunks = 43